import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import _classCallCheck from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableclipboard
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TableSelection from './tableselection';
/**
 * This plugin adds support for copying/cutting/pasting fragments of tables.
 * It is loaded automatically by the {@link module:table/table~Table} plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableClipboard = /*#__PURE__*/function (_Plugin) {
  _inherits(TableClipboard, _Plugin);

  var _super = _createSuper(TableClipboard);

  function TableClipboard() {
    _classCallCheck(this, TableClipboard);

    return _super.apply(this, arguments);
  }

  _createClass(TableClipboard, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var _this = this;

      var editor = this.editor;
      var viewDocument = editor.editing.view.document;
      this.listenTo(viewDocument, 'copy', function (evt, data) {
        return _this._onCopyCut(evt, data);
      });
      this.listenTo(viewDocument, 'cut', function (evt, data) {
        return _this._onCopyCut(evt, data);
      });
    }
    /**
     * Copies table content to a clipboard on "copy" & "cut" events.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} evt An object containing information about the handled event.
     * @param {Object} data Clipboard event data.
     */

  }, {
    key: "_onCopyCut",
    value: function _onCopyCut(evt, data) {
      var tableSelection = this.editor.plugins.get('TableSelection');

      if (!tableSelection.getSelectedTableCells()) {
        return;
      }

      if (evt.name == 'cut' && this.editor.isReadOnly) {
        return;
      }

      data.preventDefault();
      evt.stop();
      var dataController = this.editor.data;
      var viewDocument = this.editor.editing.view.document;
      var content = dataController.toView(tableSelection.getSelectionAsFragment());
      viewDocument.fire('clipboardOutput', {
        dataTransfer: data.dataTransfer,
        content: content,
        method: evt.name
      });
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'TableClipboard';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableSelection];
    }
  }]);

  return TableClipboard;
}(Plugin);

export { TableClipboard as default };